import { createPortal } from "@app/shared/utils";

export const aboutUsVideoPortal = createPortal("about-us-video");
